import React from 'react';
import { Utensils, Beef, Wheat, Carrot, Bean } from 'lucide-react';
import { menuItems } from '../mock';

const Menu = () => {
  return (
    <section id="cardapio" className="py-20 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Nosso Cardápio
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Escolha suas combinações favoritas. Pesamos a gramagem que você indicar para cada item.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="bg-gradient-to-br from-red-50 to-orange-50 rounded-2xl p-8 border-2 border-orange-200">
            <div className="flex items-center mb-6">
              <div className="w-12 h-12 bg-red-600 rounded-xl flex items-center justify-center mr-4">
                <Beef className="h-6 w-6 text-white" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900">Proteínas</h3>
            </div>
            <div className="space-y-3">
              {menuItems.proteins.map((item) => (
                <div key={item.id} className="bg-white rounded-lg p-4 shadow-sm hover:shadow-md transition-shadow">
                  <div className="font-semibold text-gray-900 mb-1">{item.name}</div>
                  <div className="text-sm text-gray-600">
                    {item.calories} kcal • {item.protein}g proteína (por 100g)
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="bg-gradient-to-br from-yellow-50 to-amber-50 rounded-2xl p-8 border-2 border-yellow-200">
            <div className="flex items-center mb-6">
              <div className="w-12 h-12 bg-yellow-600 rounded-xl flex items-center justify-center mr-4">
                <Wheat className="h-6 w-6 text-white" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900">Carboidratos</h3>
            </div>
            <div className="space-y-3">
              {menuItems.carbs.map((item) => (
                <div key={item.id} className="bg-white rounded-lg p-4 shadow-sm hover:shadow-md transition-shadow">
                  <div className="font-semibold text-gray-900 mb-1">{item.name}</div>
                  <div className="text-sm text-gray-600">
                    {item.calories} kcal • {item.carbs}g carboidratos (por 100g)
                  </div>
                </div>
              ))}
            </div>
          </div>
          
          <div className="bg-gradient-to-br from-blue-50 to-amber-50 rounded-2xl p-8 border-2 border-blue-200">
            <div className="flex items-center mb-6">
              <div className="w-12 h-12 bg-blue-600 rounded-xl flex items-center justify-center mr-4">
                <Bean className="h-6 w-6 text-white" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900">Feijão</h3>
            </div>
            <div className="space-y-3">
              {menuItems.beans.map((item) => (
                <div key={item.id} className="bg-white rounded-lg p-4 shadow-sm hover:shadow-md transition-shadow">
                  <div className="font-semibold text-gray-900 mb-1">{item.name}</div>
                  <div className="text-sm text-gray-600">
                    {item.calories} kcal • {item.carbs}g carboidratos (por 100g)
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-2xl p-8 border-2 border-green-200">
            <div className="flex items-center mb-6">
              <div className="w-12 h-12 bg-green-600 rounded-xl flex items-center justify-center mr-4">
                <Carrot className="h-6 w-6 text-white" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900">Legumes</h3>
            </div>
            <div className="space-y-3">
              {menuItems.vegetables.map((item) => (
                <div key={item.id} className="bg-white rounded-lg p-4 shadow-sm hover:shadow-md transition-shadow">
                  <div className="font-semibold text-gray-900 mb-1">{item.name}</div>
                  <div className="text-sm text-gray-600">
                    {item.calories} kcal • {item.fiber}g fibras (por 100g)
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Menu;